export default "__VITE_ASSET__OjT0gxoo__"